import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import {CheckoutIntegrationStatus} from 'src/app/models/CheckoutIntegrationEnum';
import Order from 'src/app/models/Order';

@Component({
	selector: 'app-order-item-checkout-integration-info',
	templateUrl: './order-item-checkout-integration-info.component.html',
	styleUrls: ['./order-item-checkout-integration-info.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderItemCheckoutIntegrationInfoComponent implements OnInit {
	@Input() order: Order;
	@Output() sendOrderToPOS = new EventEmitter<void>();
	@Input() loading = false;
	statusEnum = CheckoutIntegrationStatus;
	constructor() {}

	ngOnInit() {}
	checkStatusGreen(status?: CheckoutIntegrationStatus) {
		return (
			status === CheckoutIntegrationStatus.FINALIZED ||
			status === CheckoutIntegrationStatus.VERIFIED ||
			status === CheckoutIntegrationStatus.RECEIVED
		);
	}
	checkStatusRed(status?: CheckoutIntegrationStatus) {
		return (
			status === CheckoutIntegrationStatus.REJECTED ||
			status === CheckoutIntegrationStatus.CANCELED
		);
	}
	sendToPOS() {
		this.sendOrderToPOS.emit();
	}
}
